export default __webpack_public_path__ + "static/media/l2-p2.36a80f16.png";